import React, { useState, useEffect } from "react";
import { StaticImage } from "gatsby-plugin-image";

import * as styles from "./ModalProvider.module.css";

export const ModalContext = React.createContext();

const ModalProvider = ({ children }) => {
  const [isVisible, setVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const openModal = ({ content }) => {
    setVisible(true);
    setModalContent(content);
  };

  const closeModal = () => {
    setVisible(false);
    setModalContent(null);
  };

  return (
    <ModalContext.Provider value={{ openModal }}>
      {children}
      {isVisible && (
        <>
          <div
            className={styles.modalContainer}
            onClick={(e) => {
              closeModal();
            }}
          >
            <div
              className={styles.modalContent}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <div className={styles.closeContainer} onClick={closeModal}>
                <StaticImage src="../../images/close.svg" alt="Close" />
              </div>
              {modalContent}
            </div>
          </div>
        </>
      )}
    </ModalContext.Provider>
  );
};

export default ModalProvider;
